<template>
	<div class="question-view__attachment col">
		<template v-if="!file.id">
			<input type="file" v-if="!file.id" :id="'file-upload-'+fileIndex">
			<a class="file-delete" href="#" @click.prevent="deleteFile">×</a>
		</template>
		<template v-if="file.id">
			<img :src="file.preview_url" v-if="file.preview_url" alt="">
			<span class="gc-icon gc-icon-unknown" v-if="!file.preview_url"></span>
			<a :href="file.url" target="_blank">
				<span class="filename">{{file.file_name}}</span>
			</a>
			<a class="file-delete" href="#" @click.prevent="deleteFile">×</a>
		</template>
	</div>
</template>
<script>
	export default {
	name: 'FileOrPicture',
	props: ['file', 'fileIndex'],
	methods: {
		deleteFile: function () {
			this.$emit('delete-file');
		}
	}
}
</script>